import styled, { keyframes, css } from 'styled-components';
/* eslint-disable no-console */

const CartPlaceholder = () => (
    <CartPlaceholderWrapper>
        <ProductContainerPlaceholder>
            <TitlePlaceholder>
                <Animation />
            </TitlePlaceholder>
            <CartItemPlaceholder>
                <Animation />
            </CartItemPlaceholder>
            <CartBottomPlaceholder>
                <Animation />
            </CartBottomPlaceholder>
        </ProductContainerPlaceholder>
        <CartSummaryPlaceholder />
    </CartPlaceholderWrapper>
);
const loading = keyframes`
   0%{
        left: 0%;
    }
    100%{
        left: 50%;
    }
`;
const animation = css`
    ${loading} 1s infinite
`;

const CartPlaceholderWrapper = styled.div`
    display: grid;
    justify-items: center;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    max-width: 1080px;
    width: 100%;
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        padding-bottom: 120px;
        width: 100%;
    }
`;
const ProductContainerPlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 100%;
`;
const TitlePlaceholder = styled.div`
    height: 53px;
    background-color: rgb(211, 211, 211);

    width: 100%;
    @media (max-width: 768px) {
        display: none;
    }
`;
const CartItemPlaceholder = styled.div`
    height: 130px;
    background-color: rgb(211, 211, 211);
    width: 100%;
    margin: 20px 0;
    @media (max-width: 768px) {
        height: 138px;
    }
`;
const CartBottomPlaceholder = styled.div`
    height: 155px;
    background-color: rgb(211, 211, 211);
    width: 100%;
    @media (max-width: 768px) {
        height: 105px;
    }
`;
const CartSummaryPlaceholder = styled.div`
    height: 265px;
    background-color: rgb(211, 211, 211);
    width: 100%;
    @media (max-width: 768px) {
        height: 95px;
    }
`;
const Animation = styled.div`
    position: absolute;
    left: 0%;
    height: 100%;
    width: 45%;
    background-image: linear-gradient(
        to left,
        rgba(251, 251, 251, 0.05),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.6),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.05)
    );
    background-image: -moz-linear-gradient(
        to left,
        rgba(251, 251, 251, 0.05),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.6),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.05)
    );
    background-image: -webkit-linear-gradient(
        to left,
        rgba(251, 251, 251, 0.05),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.6),
        rgba(251, 251, 251, 0.3),
        rgba(251, 251, 251, 0.05)
    );
    animation: ${animation};
    z-index: 45;
`;
export default CartPlaceholder;
